import { useEffect, type ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { CookieBanner } from "./CookieBanner";
import { PriorityPartner } from "./PriorityPartner";
import { useI18n } from "@/i18n/I18nProvider";
import { Analytics } from "./Analytics";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    if (typeof window !== "undefined") window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

export function Layout({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  const { lang } = useI18n();
  // Suppress the band on Betinia's own review (already the focus) and on the
  // homepage where Betinia is already featured in the hero.
  const lower = pathname.toLowerCase();
  const onBetiniaReview =
    lower.includes("/recensioner/betinia") || lower.includes("/reviews/betinia");
  const onHomepage = lower === "/" || lower === "/sv" || lower === "/en";
  const showSpotlight = !onBetiniaReview && !onHomepage;

  return (
    <div className="flex min-h-screen flex-col">
      <ScrollToTop />
      <Analytics />
      <a href="#main" className="skip-link">
        Hoppa till innehåll / Skip to content
      </a>
      <Header />
      <main id="main" className="flex-1">
        <p className="container-page py-2 text-xs text-ink-600">
          {lang === "sv" ? "Senast uppdaterad: " : "Last updated: "}
          <time dateTime="2026-10-22">{lang === "sv" ? "22 oktober 2026" : "22 October 2026"}</time>
        </p>
        {children}
      </main>
      {showSpotlight && (
        <div className="container-page mt-12 mb-12">
          <PriorityPartner variant="band" placement="layout-band" source="layout" />
        </div>
      )}
      <Footer />
      <CookieBanner />
    </div>
  );
}
